import { Card, CardContent } from "@/components/ui/card";
import { DollarSign, Activity, Users, Heart, Check } from "lucide-react";

const features = [
  {
    icon: DollarSign,
    title: "Affordable & Transparent",
    description: "Starting at $74/month—75% less than traditional weight loss programs.",
    bullets: [
      "Transparent pricing with no hidden fees",
      "Predictable monthly costs per employee",
      "ROI tracking and outcomes reporting",
    ],
  },
  {
    icon: Activity,
    title: "Medical-Grade Solutions",
    description: "Physician-prescribed GLP-1s and custom peptide therapies.",
    bullets: [
      "Semaglutide, Tirzepatide, and custom peptides",
      "Licensed physician oversight",
      "Monthly telehealth check-ins included",
    ],
  },
  {
    icon: Users,
    title: "Community-Driven Success",
    description: "Real support from peers and providers for lasting results.",
    bullets: [
      "Monthly community wellness events",
      "Peer support groups and accountability",
      "50% lower mortality risk with strong social bonds",
    ],
  },
  {
    icon: Heart,
    title: "Holistic Transformation",
    description: "Complete wellness journey for total health improvement.",
    bullets: [
      "Coordinate weight loss with overall health goals",
      "Comprehensive metabolic health support",
      "Complete confidence transformation",
    ],
  },
];

const WhyTrueWellness = () => {
  return (
    <section className="py-20 md:py-28 bg-white relative overflow-hidden">
      {/* Background accent */}
      <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-[#0D1B2A]/5 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" />
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-sm font-bold text-[#0D1B2A]/60 uppercase tracking-[0.2em] mb-4">Why Choose Us</h2>
          <h3 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#0D1B2A] mb-6 tracking-tight">
            Why True Wellness for Your Organization
          </h3>
          <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            We're not just another weight loss app. We combine proven medical treatments with real 
            community support—all at a fraction of traditional costs.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {features.map((feature, index) => (
            <Card 
              key={index} 
              className="hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border-0 shadow-xl bg-gradient-to-br from-white to-gray-50/50 group"
            >
              <CardContent className="p-8">
                <div className="flex items-start gap-5">
                  <div className="flex-shrink-0 w-14 h-14 rounded-2xl bg-gradient-to-br from-[#0D1B2A] to-[#1B3A4B] flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform">
                    <feature.icon className="w-7 h-7 text-[#ffdb4d]" />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-bold text-[#0D1B2A] mb-3">{feature.title}</h3>
                    <p className="text-gray-600 mb-5 leading-relaxed">{feature.description}</p>
                    <ul className="space-y-3">
                      {feature.bullets.map((bullet, bulletIndex) => (
                        <li key={bulletIndex} className="flex items-start gap-3 text-sm text-gray-600">
                          <div className="w-5 h-5 rounded-full bg-green-500/10 flex items-center justify-center flex-shrink-0 mt-0.5">
                            <Check className="w-3 h-3 text-green-600" />
                          </div>
                          <span>{bullet}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyTrueWellness;
